import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let LightsaberForms = class LightsaberForms extends VuexModule {
    constructor() {
        super(...arguments);
        this.lightsaberForms = [];
        this.cachedVersion = 0;
    }
    async fetchLightsaberForms() {
        const { data: lightsaberForms, cachedVersion } = await fetchFromCache(this, 'lightsaberForms', 'lightsaberForm');
        return { lightsaberForms, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['lightsaberForms', 'cachedVersion'] })
], LightsaberForms.prototype, "fetchLightsaberForms", null);
LightsaberForms = __decorate([
    Module({ namespaced: true, name: 'lightsaberForms' })
], LightsaberForms);
export default LightsaberForms;
